import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { localKeys } from '@m2h/common/constants';
import { MACHPRO_ALERT_CLOSE } from '@m2h/common/constants/postMsg';
import {
  getI18nParams, getMerchantCashierUrl, getPaymentUrl, getPassportUinfoUrl, toLogin,
  getRegion, getCityId, getHostUrl, getLanguage,
} from '@m2h/common/utils';
import { getCombToSearchStr, getLoginAccountId, objectToQueryString } from '@m2h/common/utils/common';
import { closeAlertIframe, openAlertIframe } from '@m2h/common/utils/iframe';
import { getStoredCurrLocation } from '@m2h/common/utils/location';
import { off, on, sendParent } from '@m2h/common/utils/postMsg';
import { routerNavigate } from '@m2h/common/utils/spaRouter';
import { getChannel, isGoogleMapChannel } from '@m2h/common/utils/channelContext';
// import { bundle2h5_map } from '@m2h/router/bundle2h5_map';
import Constant from '@utils/constant';
import { toBottomDashedCase } from '@m2h/common/utils/styleUtils';
import {
  clearStoredPageMach,
  updateMachObjectWithStore,
  storeMachObject,
  replaceMachSchemeData2Window,
  storeMachSchemeData,
} from '@m2h/common/utils/machUtils';
import qs from 'qs';

import Login from './Login';
import SLCommon from './SLCommon';

const MPWEB_PATH_PREFIX = '/mpweb/';
const MP_COMMON_PREFIX_REG = /mach_pro_sailor_(c_)?/;
const MP_SAILOR_C_SCHEME = /sailorc:\/\/keeta.com\/machpro(alert)?\?/;
const MP_SAILOR_C_BROWSER_REG = /sailorc:\/\/keeta.com\/browser\?/;
const MERCHANT_CASHIER_REGIONS = new Set(['BR', 'SA', 'AE', 'KW', 'QA', 'OM', 'BH']);
const MERCHANT_CASHIER_PATH = '/merchant-cashier/cashier';

// 要自动添加golden的模块
const goldenBundle = [
  'mach_pro_sailor_c_shop',
  'mach_pro_sailor_c_order_confirm',
  'mach_pro_sailor_c_order_status',
  'mach_pro_sailor_c_order_map',
  'mach_pro_sailor_c_shop_multi_sku_modal',
  'mach_pro_sailor_c_order_map_golden', // ?
  'mach_pro_sailor_c_shop_multi_sku_modal_golden', // ?
];
const NATIVE_URLS = {
  // 'sailorc://keeta.com/home?businessType=market&scrollOffset=-0.5 ': 'order_list',
  'sailorc://keeta.com/orderlist': 'order_list',
  'sailorc://keeta.com/home': 'home_page_main',
  'sailorc://keeta.com/mine': 'mine',
};
// 跳转后，需要保持当前页状态的，废弃，已通过iframe跳转解决
const CACHE_MACHENV_BUNDLE = [
  'mach_pro_sailor_c_market_order_coupon_list',
];

// 需要登录的页面，未登录态直接跳登录
const NEED_LOGIN_BUNDLE = [
  'mach_pro_sailor_c_shop',
  'mach_pro_sailor_c_shop_golden',
  // 'mach_pro_sailor_homepage_kingkong_page',
  'mach_pro_sailor_c_channel_list_main',
  // 'mach_pro_sailor_homepage_kingkong_page',
];

const SHOP_DETAIL_BUNDLE = [
  'mach_pro_sailor_c_shop',
  'mach_pro_sailor_c_shop_golden',
];

const UNSUPPORT_BUNDLE = [
  'mach_pro_sailor_mkt_resources_home_pop_main',
];

// sailorc://keeta.com/browser?inner_url=https%3A%2F%2Fcs.mykeeta.com%2Finit.html%3Ffrom%3Dwaimai_waimai_refund_chat%26orderId%3D703441048365878%26language%3Dzh-HK%26ext%3D%257B%2522refundType%2522%253A501017%257D

const { env } = SLCommon.getEnv();
const passportPhoneUrl = env === 'Test'
  ? 'http://passport-i18n.fe.test.sankuai.com/i/change-phonenumber'
  : 'https://passport.mykeeta.com/i/change-phonenumber';

const isPassportUrl = (url: string): boolean => {
  const passportReg = /^https?:\/\/passport/; // 匹配 http 或 https 开头的 passport
  return passportReg.test(url);
};

const isPayH5Url = (url: string): boolean => {
  const passportReg = /^https?:\/\/pay/; // 匹配 http 或 https 开头的 passport
  return passportReg.test(url);
};

interface SubstringOptions {
  trim?: boolean; // 是否去除空格
  ignoreCase?: boolean; // 是否忽略大小写
  last?: boolean; // 是否查找最后一个匹配
  defaultValue?: string; // 未找到时的默认值
}

export const getCommonUrlQuerys = () => {
  const currLocaiton = getStoredCurrLocation() || {};
  return {
    ...currLocaiton,
    appVersion: Mach.env.version ?? '',
    clientType: 'c_h5',
    uuid: Mach.env.uuid ?? '',
    userId: Login.getUserId(),
    region: getRegion(),
    locale: getLanguage(),
    deviceLanguage: getLanguage(),
    cityId: getCityId(),
  };
};

export const bundle2h5_map = {
  mach_pro_sailor_c_customer_service: (schemeParams?) => {
    const queryObj = {
      ...getCommonUrlQuerys(),
      from: 'waimai_waimai_home'
    };
    return `${getHostUrl({ client: 'cs', needProtocol: true, })}/init.html?${qs.stringify(queryObj)}`;
  },
  // mach_pro_sailor_gundam_main: (schemeParams?) => {
  //   // /gundam/gd2/wm/4xeVtl?gundam_id=4xeVtl&tenant=gundam&onHideRemain=true&needLocation=1
  //   const gundam_id = schemeParams?.gundam_id;
  //   if (!gundam_id) return '';
  //   const queryObj = {
  //     ...getCommonUrlQuerys(),
  //     gundam_id,
  //     tenant: 'gundam',
  //     onHideRemain: 'true',
  //     needLocation: '1',
  //     ...schemeParams,
  //   };
  //   return `${window.top.location.origin}/gundam/gd2/wm/${gundam_id}?${qs.stringify(queryObj)}`;
  // },
};

const getSubstringAfter = (
  str: string,
  search: string,
  options?: SubstringOptions
): string => {
  const {
    trim = false,
    ignoreCase = false,
    last = false,
    defaultValue = str
  } = options || {};

  let sourceStr = str;
  let searchStr = search;

  if (ignoreCase) {
    sourceStr = str.toLowerCase();
    searchStr = search.toLowerCase();
  }

  const index = last
    ? sourceStr.lastIndexOf(searchStr)
    : sourceStr.indexOf(searchStr);

  if (index === -1) return defaultValue;

  let result = str.substring(index + search.length);
  if (trim) result = result.trim();

  return result;
};

// 获取scheme、url上query参数信息,
export const getSchemeParams = (url, schemeReg?) => {
  try {
    const machproUrl = schemeReg ? url.replace(MP_SAILOR_C_SCHEME, '') : getSubstringAfter(url, '?');
    const params = new URLSearchParams(machproUrl);
    const result: Record<string, any> = {};
    // 遍历所有参数并添加到结果对象中
    params.forEach((value, key) => {
      // Mach.env.schemeParams 上的字段，要转为下划线连接如：pageSource => Mach.env.schemeParams?.page_source
      // 二者都保留： 门店页shopId, 提单券页page_source, xuhong确认machpro没有这个自动转化逻辑
      result[key] = value;
      result[toBottomDashedCase(key)] = value;
    });
    return result;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const getBundleName = (url, bundleKey) => {
  const machproUrl = url.replace(MP_SAILOR_C_SCHEME, '');
  const params = new URLSearchParams(machproUrl);
  let bundleName = params.get(bundleKey) || '';
  if (goldenBundle.includes(bundleName)) {
    bundleName = `${bundleName}_golden`;
  }
  return bundleName;
};

export const getBrowserUrl = (url) => {
  const machproUrl = url.replace(MP_SAILOR_C_BROWSER_REG, '');
  const params = new URLSearchParams(machproUrl);
  const innerUrl = params.get('inner_url') || '';

  // 拼接公共参数到innerUrl
  let finalInnerUrl = innerUrl;
  if (innerUrl) {
    const commonParams = getCommonUrlQuerys();

    try {
      // 手动解析URL，支持hash和查询参数
      const urlObj = new URL(innerUrl);

      // 解析现有查询参数
      const existingParams = qs.parse(urlObj.search, { ignoreQueryPrefix: true });

      // 合并现有查询参数和公共参数
      const mergedQuery = {
        ...existingParams,
        ...commonParams
      };

      // 重新构建查询字符串
      const newQueryString = qs.stringify(mergedQuery, { encode: true });

      // 重新构建完整URL
      finalInnerUrl = `${urlObj.origin}${urlObj.pathname}?${newQueryString}${urlObj.hash}`;
    } catch (error) {
      // 如果URL解析失败，使用简单的字符串拼接方式
      console.warn('URL parsing failed, using fallback method:', error);

      const commonQueryString = qs.stringify(commonParams, { encode: true });

      // 处理包含hash的URL
      const hashIndex = innerUrl.indexOf('#');
      if (hashIndex !== -1) {
        // URL包含hash，需要在hash之前插入参数
        const urlBeforeHash = innerUrl.substring(0, hashIndex);
        const hashPart = innerUrl.substring(hashIndex);

        // 检查hash之前的URL是否已有参数
        const hasParams = urlBeforeHash.includes('?');
        finalInnerUrl = `${urlBeforeHash}${hasParams ? '&' : '?'}${commonQueryString}${hashPart}`;
      } else {
        // URL不包含hash，正常处理
        const hasParams = innerUrl.includes('?');
        finalInnerUrl = `${innerUrl}${hasParams ? '&' : '?'}${commonQueryString}`;
      }
    }
  }

  // 方便补充其他返回参数
  return {
    innerUrl: finalInnerUrl,
  };
};

// 对跳转是的schemeParams参数，解析JSON字符串为对象
export const transformInfo = (info: Record<string, any>) => {
  const result: Record<string, any> = {};
  Object.keys(info).forEach((key) => {
    try {
      result[key] = typeof info[key] === 'string' ? JSON.parse(decodeURIComponent(info[key])) : info[key];
    } catch {
      result[key] = info[key];
    }
  });
  return result;
};

export const RouterListener = () => {
  const location = useLocation();

  useEffect(() => {
    // 路由变化时恢复数据
    console.log('bundleName 优先级xxx RouterListener', window.Mach.env);
    updateMachObjectWithStore();

    // 记录导航历史，用于回退逻辑判断
    const currentPath = location.pathname;
    const navigationHistory = JSON.parse(sessionStorage.getItem('navigationHistory') || '[]');

    // 避免重复记录相同路径
    if (navigationHistory[navigationHistory.length - 1] !== currentPath) {
      navigationHistory.push(currentPath);

      // 限制历史记录长度，避免内存泄漏
      if (navigationHistory.length > 10) {
        navigationHistory.shift();
      }

      sessionStorage.setItem('navigationHistory', JSON.stringify(navigationHistory));
    }
  }, [location]);

  return null;
};

const closeLoading = () => {
  const indicatorModule = Mach?.requireModule('ActivityIndicator');
  indicatorModule?.hideLoading?.();
};

// 支付公参
const getPayH5CommonParams = () => {
  const regionMerchantId = {
    SA: '10030000001',
    HK: '10010000001',
  };

  const i18nQuerys = getI18nParams() || { region: getRegion() };

  const {
    uuid,
  } = Mach.env || {};

  return {
    intlH5TitleBar: '1',
    uuid,
    userId: getLoginAccountId(),
    // @ts-ignore
    merchantId: regionMerchantId[i18nQuerys.region || 'HK'] || '10010000001', // 沙特：10030000001香港：10010000001
    ...i18nQuerys, // cityId、region、locale
    // location: '', // TODO
  };
};

// 弹窗关闭监听
// const listenAlertClose = () => {
//   closeAlertIframe();
//   console.log('closeAlertIframe');
//   off(MACHPRO_ALERT_CLOSE, listenAlertClose);
// };
//
// const onAlertIframeClose = () => {
//   on(MACHPRO_ALERT_CLOSE, listenAlertClose);
// };

const module = {
  navigateTo(url, info, cb, useIframe?, replace?: boolean) {
    // https://km.sankuai.com/collabpage/1205105696
    try {
      console.log(url);
      const isLogin = Login?.isLogin?.();
      // TODO: 待优化、抽取、精简
      closeLoading();
      // 清理data 和 env.schemeParams,不是所有情况都先清除，可能还要恢复， 暂无逻辑
      // clearStoredPageMach();
      const urlArr = url?.split('?');

      if (NATIVE_URLS[urlArr[0]]) {
        Mach.data = { ...info };
        storeMachObject();
        // native页面路由跳转
        routerNavigate(`${MPWEB_PATH_PREFIX}${NATIVE_URLS[urlArr[0]]}${urlArr[1] ? `?${urlArr[1]}` : ''}`);
        // clearStoredPageMach();
      // } else if (url.startsWith('sailorc://keeta.com/machpro?gundam_id=')) {
      } else if (url.startsWith('sailorc://keeta.com/machpro?')) {
        Mach.data = { ...info };
        // 跳machpro页面
        const bundleName = getBundleName(url, 'mach_bundle_name');
        const innerUrl = url?.split('?')[1]?.split('&')[1]?.split('=')[1] || '';
        if (!bundleName) {
          cb?.({ success: false });
          return '';
        }
        const bundlePath = bundleName.replace(MP_COMMON_PREFIX_REG, `${MPWEB_PATH_PREFIX}`);

        const parsedSchemeParams = getSchemeParams(url, MP_SAILOR_C_SCHEME);
        // Router 只消费 channel，不在跳转过程中修改全局状态或 sessionStorage。
        const channel = parsedSchemeParams.channel || getChannel();
        // googlemap 门店入口允许免登录；必须在登录判断前完成 channel 读取。
        const isGoogleMapShop = isGoogleMapChannel(channel) && SHOP_DETAIL_BUNDLE.includes(bundleName);

        if (!isLogin && NEED_LOGIN_BUNDLE.includes(bundleName) && !isGoogleMapShop) {
          // 需要登录的页面
          toLogin();
          cb?.({ success: true });
          return;
        }

        // 页面跳转的时候需要定义全局的环境变量
        const schemeParams = {
          data: {},
          inner_url: decodeURIComponent(innerUrl),
          // 恢复出的 channel 也写入目标页配置，避免页面首个请求早于初始化 Hook。
          ...parsedSchemeParams,
          ...(channel ? { channel } : {}),
        };
        const machConfig = {
          env: { schemeParams },
          data: {
            ...info,
            ...schemeParams.data,
          }
        };
        const localKey = `${localKeys.LOCAL_MACH_SCHEME_DATA}${bundlePath}`;
        console.log('bundleName 优先级', bundlePath, localKey);
        storeMachSchemeData({ localKey, machConfig });

        // schemeParams信息同步到window, 但不存local/session
        // replaceMachSchemeData2Window(machConfig, true); // 不存，此时路由pathname还没变更完
        console.log('bundleName 优先级xxx Router', window.Mach.env);

        if (useIframe) {
          // 需要处理从已有iframe再navigateToForResult开iframe的情况
          // 注意: 不在 onload 中保存大量闭包引用,避免内存泄漏
          openAlertIframe({
            url: bundlePath,
            onload: (e: Event) => {
              const alertFrame = e.target as HTMLIFrameElement;
              if (alertFrame.contentWindow) {
                // 只传递必要的数据,避免持有大量闭包引用
                if (schemeParams?.data) {
                  const originMach = alertFrame.contentWindow.Mach;
                  alertFrame.contentWindow.Mach = {
                    ...Mach,
                    requireBundleAsync: originMach.requireBundleAsync,
                    requireModule: originMach.requireModule,
                    pageInitConfig: originMach.pageInitConfig,
                    data: {
                      ...(window.Mach?.data || {}),
                      ...schemeParams.data,
                    },
                  };
                }
              }
            },
          });
          // onAlertIframeClose();
          cb?.({ success: true });
          return;
        }

        // 客服等特殊跳转逻辑
        if (bundle2h5_map[bundleName]) {
          const bundle2h5Url = bundle2h5_map[bundleName]?.(schemeParams);
          bundle2h5Url && (window.location.href = bundle2h5Url);
          // @ts-ignore
        } else if (schemeParams?.gundam_id) {
          // /gundam/gd2/wm/4xeVtl?gundam_id=4xeVtl&tenant=gundam&onHideRemain=true&needLocation=1
          // @ts-ignore
          const gundam_id = schemeParams?.gundam_id;
          const queryObj = {
            ...getCommonUrlQuerys(),
            gundam_id,
            tenant: 'gundam',
            onHideRemain: 'true',
            needLocation: '1',
            ...schemeParams,
          };
          openAlertIframe({
            url: `${window.top.location.origin}/gundam/gd2/wm/${gundam_id}?${qs.stringify(queryObj)}`,
            onload: (e: Event) => {
              const alertFrame = e.target as HTMLIFrameElement;
              if (alertFrame.contentWindow) {
                // 只传递必要的数据,避免持有大量闭包引用
                if (schemeParams?.data) {
                  alertFrame.contentWindow.Mach = {
                    ...Mach,
                    data: {
                      ...(window.Mach?.data || {}),
                      ...schemeParams.data,
                    },
                  };
                }
              }
            },
          });
          // onAlertIframeClose();
        } else if (CACHE_MACHENV_BUNDLE.includes(bundleName)) {
          // 提单页等，需要保存页面数据的
          // mach_pro_sailor_c_market_order_coupon_list
          routerNavigate(bundlePath, { replace });
        } else {
          // ----- mpweb适配origin -----
          // routerNavigate(bundlePath);
          // ----- mpweb适配change -----
          // replace 透传：调用方（如退款提交成功跳详情）可用 replace 把当前页从
          // 历史栈替换掉，返回时自然跳过本页，等效 Native 的双重返回净效果。
          routerNavigate(bundlePath, { replace });
          // ----- mpweb适配       -----
        }
      } else if (url.startsWith('sailorc://keeta.com/machproalert?')) {
        Mach.data = { ...info };
        // 跳machpro弹窗
        // 弹窗 sailorc://keeta.com/machproalert iframe
        const bundleName = getBundleName(url, 'bundle_name');
        if (!bundleName || UNSUPPORT_BUNDLE.includes(bundleName)) {
          cb?.({ success: false });
          return '';
        }
        const pathName = `${bundleName.replace(MP_COMMON_PREFIX_REG, '/mpweb/')}`;
        const bundlePath = `${window.location.origin}${pathName}?mpwebAlert=1`;
        // const bundlePath = `${bundleName.replace(MP_COMMON_PREFIX_REG, `${window.location.origin}/mpweb/`)}?mpwebAlert=1`;
        const schemeParams = {
          data: {},
          ...transformInfo(getSchemeParams(url, MP_SAILOR_C_SCHEME))
        };
        // 弹窗路由同样只透传当前 channel，持久化由 HTML 入口统一负责。
        const channel = schemeParams.channel || getChannel();
        if (channel) schemeParams.channel = channel;
        console.log('---url---', url, schemeParams);
        const machConfig = {
          env: { schemeParams },
          data: {
            ...info,
            ...schemeParams.data,
          }
        };
        const localKey = `${localKeys.LOCAL_MACH_SCHEME_DATA}${pathName}`;
        console.log('bundleName 优先级', pathName, machConfig, schemeParams.data, 'info', info);
        storeMachSchemeData({ localKey, machConfig });
        // replaceMachSchemeData2Window(machConfig, true);
        // iframe打开页面，如何提前生效Machpro参数字段？
        openAlertIframe({
          url: bundlePath,
          onload: (e: Event) => {
            const alertFrame = e.target as HTMLIFrameElement;
            if (alertFrame.contentWindow) {
              // 只传递必要的数据,避免持有大量闭包引用
              if (schemeParams?.data) {
                alertFrame.contentWindow.Mach = {
                  ...Mach,
                  data: {
                    ...(window.Mach?.data || {}),
                    ...schemeParams.data,
                  },
                };
              }
            }
          },
        });
        // onAlertIframeClose();
      } else if (url.startsWith('sailorc://keeta.com/browser?')) {
        Mach.data = { ...info };
        storeMachObject();
        // titans 容器路径
        const { innerUrl } = getBrowserUrl(url);
        if (innerUrl) {
          // TODO 其他兼容判断
          window.location.href = innerUrl;
          // window.open(innerUrl, '');
        } else {
          cb?.({ success: false });
          return;
        }
      } else if (url.startsWith('http') || isPassportUrl(url)) {
        Mach.data = { ...info };
        storeMachObject();
        // https? web页面或passport页面
        console.log('---url---', url);
        if (isPayH5Url(url)) {
          // 支付页面拼接参数
          const payH5CommonParams = getPayH5CommonParams();
          const urlQueryString = objectToQueryString({
            ...payH5CommonParams,
          });
          const originQuery = getSubstringAfter(url, '?', { defaultValue: '' });
          let newUrl = url.replace(/^https?:\/\/pay\.mykeeta(?:\.(?:test|st))?(?:\.com|\.(?:st|test)\.sankuai\.com)$/, getPaymentUrl(true, true)); // 添加域名泳道
          window.location.href = `${newUrl}${originQuery ? '&' : '?'}${urlQueryString}`;
          cb?.({ success: true });
          return;
        } if (url.includes(passportPhoneUrl)) {
          const passportUinfoUrl = getPassportUinfoUrl();
          const querySeparator = passportUinfoUrl.includes('?') ? '&' : '?';
          const passportPhoneQuery = objectToQueryString({
            editTarget: 'phone',
            from_source: 'web-gmap',
          });
          window.location.href = `${passportUinfoUrl}${querySeparator}${passportPhoneQuery}`;
        } else {
          window.location.href = url;
        }
      } else if (url.startsWith(Constant.SCHEME_PAY)) {
        Mach.data = { ...info };
        storeMachObject();
        // 支付收银台跳转 'sailorpayment://cashier/launch'
        // sailorpayment://cashier/launch?trade_number=250604000000100100011056241486&pay_token=0aa38aafb4e7a9ed9d769a65109151b0&callback_url=sailorc%3A%2F%2Fkeeta.com%2Fmachpro%3Fmach_bundle_name%3Dmach_pro_sailor_c_order_status%26orderViewId%3D553442177376394%26source%3D2&locale=zh-HK&merchant_id=10010000001
        console.log('支付收银台跳转：', url);

        // 修改历史记录为订单列表页
        const navigationHistory = ['/mpweb/order_list'];
        sessionStorage.setItem('navigationHistory', JSON.stringify(navigationHistory));

        const schemeParams = getSchemeParams(url);
        const region = getRegion();
        // ----- mpweb适配origin -----
        // Merchant Cashier 旧版参数不包含定位和订单来源字段。
        // ----- mpweb适配change -----
        const locationInfo = getStoredCurrLocation() || {};
        const latitude = locationInfo.latitude ?? locationInfo.actualLatitude;
        const longitude = locationInfo.longitude ?? locationInfo.actualLongitude;
        const cashierLocation = latitude && longitude ? `${latitude}_${longitude}` : '';
        const orderSource = isGoogleMapChannel(getChannel()) ? 'GoogleMap' : 'Browser';
        // ----- mpweb适配       -----
        const newSearchStr = getCombToSearchStr({ paySuccCb: 1 });
        const paymentBackUrl = `${window.location.origin}/mpweb/order_status_golden${newSearchStr}${location.hash}`;
        let paymentH5Url = '';

        if (MERCHANT_CASHIER_REGIONS.has(region)) {
          const merchantCashierQuery = objectToQueryString({
            trade_no: schemeParams.trade_number,
            pay_token: schemeParams.pay_token,
            return_url: paymentBackUrl,
            merchant_id: schemeParams.merchant_id,
            forex_biz_identity: schemeParams.forex_biz_identity,
            locale: schemeParams.locale || getLanguage(),
            user_id: getLoginAccountId(),
            region,
            // ----- mpweb适配origin -----
            // Merchant Cashier 旧版未传 city_id、location、order_source、product_code。
            // ----- mpweb适配change -----
            city_id: getCityId(),
            location: cashierLocation,
            order_source: orderSource,
            product_code: 'Checkout',
            env: 'h5',
            // ----- mpweb适配       -----
          });
          paymentH5Url = `${getMerchantCashierUrl(true)}${MERCHANT_CASHIER_PATH}?${merchantCashierQuery}`;
        } else {
          const queryKeysMap = {
            trade_number: 'tradeNo',
            pay_token: 'payToken',
            forex_biz_identity: 'forexBizIdentity',
          };

          const schemeQuerys = Object.entries(queryKeysMap)
            .reduce((p, [schemeKey, queryKey]) =>
              ({ ...p, [queryKey]: schemeParams[schemeKey] }), {});

          // 必待字段及值
          // TODO，拼接父级窗口的query参数
          const otherQuerys = {
            callbackUrl: encodeURIComponent(paymentBackUrl),
          };

          const payH5CommonParams = getPayH5CommonParams();

          const urlQueryString = objectToQueryString({
            ...payH5CommonParams,
            ...schemeQuerys,
            ...otherQuerys,
          });

          const paymentH5Path = `/intl-standard-cashier/index.html?${urlQueryString}`;
          paymentH5Url = `${getPaymentUrl(true, true)}${paymentH5Path}`;
        }
        window.location.href = paymentH5Url;
        // 需要处理会跳逻辑，可在callbackUrl中加上参数标识
        // openAlertIframe({ url: paymentH5Url });
      } else {
        // Mach.data = { ...info };
        // storeMachObject();
        console.log('unhandled url', url, info);
        cb?.({ success: false });
        return;
      }
      cb && cb({ success: true });
    } catch (error) {
      console.log(error);
      cb && cb({ success: false, error, });
    }
  },
  navigateBack(options?, callback?) {
    const callbackFn = typeof options === 'function' ? options : callback;
    const rawDelta = typeof options === 'object' && options ? Number(options.delta) : 1;
    const delta = Number.isFinite(rawDelta) && rawDelta > 0 ? Math.floor(rawDelta) : 1;
    const finish = (result: boolean) => callbackFn?.({ result });

    try {
      closeLoading();

      // 检查当前页面是否需要特殊的回退处理
      const currentPath = window.location.pathname;

      // -------------特定回退逻辑
      // 从订单状态页面回退，统一会订单列表页
      if (currentPath === '/mpweb/order_status_golden') {
        // 特定页面直接跳转到主页
        routerNavigate('/mpweb/order_list');
        sendParent(MACHPRO_ALERT_CLOSE);
        finish(true);
        return;
      }
      // 从订单状态页面回退，统一会订单列表页
      // if (currentPath === '/mpweb/order_status_golden') {
      //   // 检查是否有历史记录
      //   if (window.history.length > 1) {
      //     // 尝试获取前一个页面的路径
      //     const referrer = document.referrer;
      //     const referrerPath = referrer ? new URL(referrer).pathname : '';
      //
      //     console.log('referrer:', referrer, referrerPath);
      //     // 如果前一个页面是订单确认页面，直接跳转到主页 || 或支付页面
      //     // referrer
      //     if (
      //       referrerPath === '/mpweb/order_confirm_golden'
      //       || referrer.includes('pay.mykeeta')
      //       || referrer.includes('pay-eu.mykeeta')
      //     ) {
      //       routerNavigate('/mpweb/order_list');
      //       return;
      //     }
      //
      //     // 使用 sessionStorage 检查导航历史
      //     const navigationHistory = JSON.parse(sessionStorage.getItem('navigationHistory') || '[]');
      //     if (navigationHistory.length > 1) {
      //       const previousPage = navigationHistory[navigationHistory.length - 2];
      //       if (previousPage === '/mpweb/order_confirm_golden') {
      //         routerNavigate('/mpweb/order_list');
      //         return;
      //       }
      //     }
      //   }
      // }

      // 检查是否有历史记录可以返回, 没有可返回的页时，回到首页
      if (window.history.length > 1) {
        // -------------统一回首页逻辑
        // 无历史记录，或有历史记录但当前再最早的页面（不在回退了）
        // 仅顶层页面生效
        if (window.self === window.top && window.history.length > 1 && window.history.state?.idx === 0) {
          // 没有历史记录时跳转到主页
          routerNavigate('/mpweb');
          finish(true);
          return;
        }

        // 尝试回退，如果无法回退则跳转到主页
        const currentUrl = window.location.href;

        // 监听 popstate 事件来检测是否成功回退
        const handlePopState = () => {
          window.removeEventListener('popstate', handlePopState);
        };

        // 设置超时检测，如果回退失败则跳转到主页
        // const timeoutId = setTimeout(() => {
        //   window.removeEventListener('popstate', handlePopState);
        //   // 如果URL没有变化，说明回退失败，跳转到主页
        //   if (window.location.href === currentUrl) {
        //     routerNavigate('/mpweb');
        //   }
        // }, 100);

        // window.addEventListener('popstate', () => {
        //   clearTimeout(timeoutId);
        //   handlePopState();
        // });

        try {
          routerNavigate(-delta);
        } catch (error) {
          // 回退失败时跳转到主页
          // timeoutId && clearTimeout(timeoutId);
          // window.removeEventListener('popstate', handlePopState);
          routerNavigate('/mpweb');
        }
      } else {
        // 没有历史记录时跳转到主页
        routerNavigate('/mpweb');
      }
      finish(true);
    } catch (error) {
      console.log('navigateBack failed', error);
      finish(false);
    }
  },
  navigateToForResult(url, info, cb, useIframe = true) {
    // 要能实现新页面，返回时能往前一个页面set数据的功能，只能新开iframe
    // 需要处理从已有iframe再navigateToForResult开iframe的情况
    // cb是用于KNB.setResult中调起的用的
    const resultCallback = typeof cb === 'function' ? cb : null;
    let initialFailureSettled = false;
    if (resultCallback) KNB.__navigateToForResultCb = resultCallback;

    return this.navigateTo(url, info, (navigateResult) => {
      if (navigateResult?.success || !resultCallback || initialFailureSettled) return;
      initialFailureSettled = true;
      if (KNB.__navigateToForResultCb === resultCallback) {
        KNB.__navigateToForResultCb = null;
      }
      resultCallback({ resultCode: 0, resultData: '' });
    }, Boolean(resultCallback) && useIframe);
  },
};

export default module;
